<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-ums__memberrelation}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item v-if="visible">
          <el-select v-model="dataForm.orgId" placeholder="请选择区域">
            <el-option label="全选" value="" key=""></el-option>
            <el-option
                    v-for="item in orgList"
                    :key="item.id"
                    :label="item.orgName"
                    :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.mobileNumber" placeholder="手机号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.memberName" placeholder="会员姓名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.isDirector" placeholder="请选择董事身份">
            <el-option v-for="item in isDirectors"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
<!--        <el-form-item>-->
<!--          <el-button v-if="$hasPermission('ums:memberrelation:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>-->
<!--        </el-form-item>-->
<!--        <el-form-item>-->
<!--          <el-button v-if="$hasPermission('ums:memberrelation:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>-->
<!--        </el-form-item>-->
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column prop="orgName" label="所属区域" header-align="center" align="center"></el-table-column>
        <el-table-column prop="memberName" label="会员姓名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="mobileNumber" label="手机号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="isDirector" label="董事身份" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isDirector==0">会员</el-tag>
            <el-tag v-else-if="scope.row.isDirector==1">董事一</el-tag>
            <el-tag v-else-if="scope.row.isDirector==2">董事二</el-tag>
            <el-tag v-else-if="scope.row.isDirector==3">董事三</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('ums:memberrelation:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">修改董事身份</el-button>
<!--            <el-button v-if="$hasPermission('ums:memberrelation:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>-->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './memberrelation-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      visible: false,
      orgList: [],
      mixinViewModuleOptions: {
        getDataListURL: '/ums/memberrelation/page',
        getDataListIsPage: true,
        exportURL: '/ums/memberrelation/export',
        deleteURL: '/ums/memberrelation',
        deleteIsBatch: true,
        activatedIsNeed: false
      },
      isDirectors:
              [{
        value: '',
        label: ''
      },{
      value: 0,
              label: '会员'
    },{
      value: 1,
              label: '董事一'
    },{
      value: 2,
              label: '董事二'
    },{
      value: 3,
              label: '董事三'
    }],
      dataForm: {
        mobileNumber: '',
        memberName: '',
        isDirector: '',
        orgId: '',
        orgName:'',
        isHead:false
      }
    }
  },
  mounted() {
    const that = this;
    that.getInfo();
  },
  methods: {
    getInfo() {
      this.$http.get(`/sys/user/info`).then(({data: res}) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm.orgId=res.data.orgId
        this.dataForm.orgName=res.data.orgName
        this.dataForm.isHead=res.data.isHead;
        if (this.dataForm.isHead) {
          this.visible=true;
          this.getOrgList();
        }
        if(!this.mixinViewModuleOptions.activatedIsNeed){
          this.getDataList()
        }
      }).catch(() => {
      })
    },
    // 获取部门列表
    getOrgList() {
      return this.$http.get('/sys/org/select').then(({data: res}) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.orgList = res.data
      }).catch(() => {
      })
    },
  },
  components: {
    AddOrUpdate
  }
}
</script>
